import splashImgSource from "$/splash.svg";
// import { useRouter } from "@tanstack/react-router";
import { motion, AnimatePresence } from "framer-motion";
import { twMerge } from "tailwind-merge";

// import { useEffect } from "react";
interface SplashProps {
  visible?: boolean;
  className?: string;
}
export const Splash = ({ visible, className }: SplashProps) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{
            transform: "scale(1.1)",
          }}
          animate={{
            transform: "scale(1)",
          }}
          exit={{
            opacity: 0,
          }}
          // onTransitionEnd={handleTransitionEnd}
          className={twMerge(
            "fixed flex inset-0 bg-yellow content-center z-20",
            className
          )}
        >
          <div className="m-auto w-fit text-center">
            <img src={splashImgSource} alt="멍투데이" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
